import * as React from 'react';
export const KZSvg = React.forwardRef(function KZSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#45B2E8',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#047A9D',
        fillOpacity: 0.199,
        opacity: 0.7,
        d: 'M1 1h4v9H1z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M8.5 8a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5ZM2 2h2v1H2V2Zm0 2h2v1H2V4Zm0 2h2v1H2V6Zm0 2h2v1H2V8Z',
      }),
    ),
  );
});
KZSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var KZ = {
  category: 'flag',
  colorable: false,
  name: 'KZ',
  svg: KZSvg,
};
